// extracted by mini-css-extract-plugin
export var clutchIcon = "SocialMediaIcon-module--clutchIcon--3bc18";
export var fadeInAnimation = "SocialMediaIcon-module--fadeInAnimation--e92b8";
export var icon = "SocialMediaIcon-module--icon--c671b";
export var link = "SocialMediaIcon-module--link--352f9";